import React, { useState, useEffect } from 'react';
import { Menu, X, Phone, Mail } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/95 backdrop-blur-md shadow-md' : 'bg-white/80 backdrop-blur-sm'
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <img
              src="https://res.cloudinary.com/dvgxmptzp/image/upload/v1767179026/s4_homes_logo_2819ce.png"
              alt="S4 Homes Logo"
              className="h-14 w-auto"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('home')}
              className="text-gray-700 hover:text-orange-600 font-medium transition-colors"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="text-gray-700 hover:text-orange-600 font-medium transition-colors"
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="text-gray-700 hover:text-orange-600 font-medium transition-colors"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('process')}
              className="text-gray-700 hover:text-orange-600 font-medium transition-colors"
            >
              Process
            </button>
            <button
              onClick={() => scrollToSection('projects')}
              className="text-gray-700 hover:text-orange-600 font-medium transition-colors"
            >
              Projects
            </button>
            <button
              onClick={() => scrollToSection('packages')}
              className="text-gray-700 hover:text-orange-600 font-medium transition-colors"
            >
              Packages
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-gray-700 hover:text-orange-600 font-medium transition-colors"
            >
              Contact
            </button>
          </nav>

          {/* Desktop CTA */}
          <div className="hidden lg:flex items-center space-x-4">
            <a href="tel:+919738477839" className="flex items-center text-gray-700 hover:text-orange-600 transition-colors">
              <Phone className="w-4 h-4 mr-2" />
              <span className="text-sm font-medium">+91 9738 477 839</span>
            </a>
            <Button
              onClick={() => scrollToSection('contact')}
              className="bg-orange-600 hover:bg-orange-700 text-white"
            >
              Get Quote
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden p-2 text-gray-700 hover:text-orange-600 transition-colors"
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden py-4 border-t border-gray-200">
            <nav className="flex flex-col space-y-4">
              <button
                onClick={() => scrollToSection('home')}
                className="text-left text-gray-700 hover:text-orange-600 font-medium transition-colors"
              >
                Home
              </button>
              <button
                onClick={() => scrollToSection('about')}
                className="text-left text-gray-700 hover:text-orange-600 font-medium transition-colors"
              >
                About
              </button>
              <button
                onClick={() => scrollToSection('services')}
                className="text-left text-gray-700 hover:text-orange-600 font-medium transition-colors"
              >
                Services
              </button>
              <button
                onClick={() => scrollToSection('process')}
                className="text-left text-gray-700 hover:text-orange-600 font-medium transition-colors"
              >
                Process
              </button>
              <button
                onClick={() => scrollToSection('projects')}
                className="text-left text-gray-700 hover:text-orange-600 font-medium transition-colors"
              >
                Projects
              </button>
              <button
                onClick={() => scrollToSection('packages')}
                className="text-left text-gray-700 hover:text-orange-600 font-medium transition-colors"
              >
                Packages
              </button>
              <button
                onClick={() => scrollToSection('contact')}
                className="text-left text-gray-700 hover:text-orange-600 font-medium transition-colors"
              >
                Contact
              </button>
              <div className="pt-4 flex flex-col space-y-3">
                <a href="tel:+919738477839" className="flex items-center text-gray-700">
                  <Phone className="w-4 h-4 mr-2" />
                  <span className="text-sm">+91 9738 477 839</span>
                </a>
                <Button
                  onClick={() => scrollToSection('contact')}
                  className="bg-orange-600 hover:bg-orange-700 text-white w-full"
                >
                  Get Quote
                </Button>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;